module.exports = __webpack_public_path__ + "img/france-diseases-of-the-nervous-system-male.a9292352.png";